import {
  SET_BULK_TAGS_REFERENCES,
  SET_BULK_TAGS,
  SET_BULK_TAGS_URL
} from './mutationTypes';

import { 
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError
} from '@/store/helpers';


export default {
  setActionStatusPending,
  setActionStatusSuccess,
  setActionStatusError,
  [SET_BULK_TAGS](state, bulkTags) {
    state.bulkTags = bulkTags;
  },
  [SET_BULK_TAGS_URL](state, bulkTagsUrl) {
    state.bulkTagsUrl = bulkTagsUrl;
  },
  [SET_BULK_TAGS_REFERENCES](state, references) {
    state.references = references;
  },
};